import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-9b2566c0")

_pushScopeId("data-v-9b2566c0")
const _hoisted_1 = { class: "allowance-application" }
const _hoisted_2 = { class: "allowance-detail" }
const _hoisted_3 = { class: "font-size-24 font-bold" }
const _hoisted_4 = { class: "mt-8" }
const _hoisted_5 = { class: "mb-8" }
const _hoisted_6 = { class: "font-bold text-lg mb-1" }
const _hoisted_7 = /*#__PURE__*/_createVNode("div", { class: "divider-light-blue mb-4" }, null, -1)
const _hoisted_8 = { class: "text-xl" }
const _hoisted_9 = { class: "mb-4" }
const _hoisted_10 = { class: "font-bold text-lg mb-1" }
const _hoisted_11 = /*#__PURE__*/_createVNode("div", { class: "divider-light-blue mb-4" }, null, -1)
const _hoisted_12 = { class: "mb-1 font-bold text-sm" }
const _hoisted_13 = { class: "text-xl flex items-center" }
const _hoisted_14 = { class: "w-24 mr-3" }
const _hoisted_15 = { class: "mb-8" }
const _hoisted_16 = { class: "mb-1 font-bold text-sm" }
const _hoisted_17 = { class: "text-xl flex items-center" }
const _hoisted_18 = { class: "w-104 mr-3" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_BackPreviousPage = _resolveComponent("BackPreviousPage")
  const _component_Select = _resolveComponent("Select")
  const _component_ReasonCreateApplication = _resolveComponent("ReasonCreateApplication")
  const _component_ApplicationApproveFlowDetail = _resolveComponent("ApplicationApproveFlowDetail")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _createVNode(_component_BackPreviousPage, { onClick: _ctx.returnScreen }, null, 8, ["onClick"]),
      _createVNode("div", _hoisted_2, [
        _createVNode("div", _hoisted_3, _toDisplayString(_ctx.t('waitingAllowanceApplication')), 1),
        _createVNode("div", _hoisted_4, [
          _createVNode("div", _hoisted_5, [
            _createVNode("div", _hoisted_6, _toDisplayString(_ctx.t('stampRegister.targetDate')), 1),
            _hoisted_7,
            _createVNode("div", _hoisted_8, _toDisplayString(_ctx.targetDate), 1)
          ]),
          _createVNode("div", _hoisted_9, [
            _createVNode("div", _hoisted_10, _toDisplayString(_ctx.t('applicationApprovalContent.title')), 1),
            _hoisted_11,
            _createVNode("div", _hoisted_12, _toDisplayString(_ctx.t('timeCardNew.numberOfWaits')), 1),
            _createVNode("div", _hoisted_13, [
              _createVNode("div", _hoisted_14, [
                _createVNode(_component_Select, {
                  disabled: "",
                  "options-select": _ctx.optionSelect,
                  modelValue: _ctx.apiPostData.wait_numbers,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.apiPostData.wait_numbers = $event))
                }, {
                  noData: _withId(() => [
                    _createTextVNode(_toDisplayString(_ctx.t('noDataAllow')), 1)
                  ]),
                  _: 1
                }, 8, ["options-select", "modelValue"])
              ]),
              _createVNode("div", null, _toDisplayString(_ctx.t('times')), 1)
            ])
          ]),
          _createVNode("div", _hoisted_15, [
            _createVNode("div", _hoisted_16, _toDisplayString(_ctx.t('attendanceOrganization')), 1),
            _createVNode("div", _hoisted_17, [
              _createVNode("div", _hoisted_18, [
                _createVNode(_component_Select, {
                  "options-select": _ctx.unitList,
                  itemValue: "unit_id",
                  itemText: "unit_name",
                  placeholder: _ctx.t('pleaseEnterTheAttendanceOrganization'),
                  modelValue: _ctx.apiPostData.checkin_unit_id,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.apiPostData.checkin_unit_id = $event))
                }, {
                  noData: _withId(() => [
                    _createTextVNode(_toDisplayString(_ctx.t('noDataAllow')), 1)
                  ]),
                  _: 1
                }, 8, ["options-select", "placeholder", "modelValue"])
              ])
            ])
          ]),
          _createVNode(_component_ReasonCreateApplication, {
            "is-valid": !_ctx.isDisableSubmit,
            modelValue: _ctx.apiPostData.application_reason,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.apiPostData.application_reason = $event)),
            validated: _ctx.validated,
            errors: _ctx.errors.application_reason,
            "onUpdate:errors": _cache[4] || (_cache[4] = ($event: any) => (_ctx.errors.application_reason = $event)),
            "error-server": _ctx.errorsServer.application_reason,
            onHandleCreateApplication: _ctx.createAllowanceApplication,
            onHandleCancel: _ctx.backToTimeCard
          }, null, 8, ["is-valid", "modelValue", "validated", "errors", "error-server", "onHandleCreateApplication", "onHandleCancel"])
        ])
      ])
    ]),
    _createVNode(_component_ApplicationApproveFlowDetail)
  ], 64))
})